module.exports = __webpack_public_path__ + "img/feature-3@2x.81f8d3ed.jpg";